import React, { useState } from "react";
import {
  Box,
  ButtonBase,
  Divider,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { BiChevronDown } from "react-icons/bi";
import { MdSwapHoriz, MdSwapVert } from "react-icons/md";
import { BudgetItemTypeEnum } from "../../../../types/budget/budget";

type Props = {
  categoryType: keyof typeof BudgetItemTypeEnum;
  /** Abre o modal "Mover categoria para outra forma de cobrança". */
  onMoveBillingModel: (type: keyof typeof BudgetItemTypeEnum) => void;
  /** Abre o modal "Transferir categoria para outro fornecedor". */
  onTransferSupplier: (type: keyof typeof BudgetItemTypeEnum) => void;
  disabled?: boolean;
};

const MoveCategorySelect: React.FC<Props> = ({
  categoryType,
  onMoveBillingModel,
  onTransferSupplier,
  disabled = false,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event?: React.MouseEvent) => {
    event?.stopPropagation();
    setAnchorEl(null);
  };

  const handleSelect = (
    event: React.MouseEvent,
    action: (type: keyof typeof BudgetItemTypeEnum) => void,
  ) => {
    // O botão vive dentro de um AccordionSummary: sem o stopPropagation o
    // clique também abre/fecha a categoria por baixo do modal.
    event.stopPropagation();
    handleClose();
    action(categoryType);
  };

  return (
    <>
      <ButtonBase
        onClick={handleClick}
        disabled={disabled}
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#E9E9EA",
          borderRadius: "6px",
          border: "1px solid #ccc",
          height: "32px",
          overflow: "hidden",
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? "default" : "pointer",
          "&:hover": {
            backgroundColor: "#ddd",
            borderColor: "#aaa",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            px: 1.2,
            height: "100%",
          }}
        >
          <span
            style={{
              fontSize: 13,
              fontWeight: 500,
              color: "#333",
              fontFamily: "sans-serif",
              whiteSpace: "nowrap",
            }}
          >
            Mover
          </span>
        </Box>
        <Divider
          orientation="vertical"
          flexItem
          sx={{ borderColor: "#bbb" }}
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 0.6,
            height: "100%",
          }}
        >
          <BiChevronDown size={18} color="#555" />
        </Box>
      </ButtonBase>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose()}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            minWidth: 300,
            maxWidth: 420,
          },
        }}
      >
        <MenuItem
          onClick={(e) => handleSelect(e, onMoveBillingModel)}
          sx={{ whiteSpace: "normal", py: 1.2 }}
        >
          <ListItemIcon sx={{ minWidth: 34 }}>
            <MdSwapVert size={20} color="#1361A4" />
          </ListItemIcon>
          <ListItemText
            primary="Mover para outra forma de cobrança"
            primaryTypographyProps={{ fontSize: 14 }}
          />
        </MenuItem>
        <MenuItem
          onClick={(e) => handleSelect(e, onTransferSupplier)}
          sx={{ whiteSpace: "normal", py: 1.2 }}
        >
          <ListItemIcon sx={{ minWidth: 34 }}>
            <MdSwapHoriz size={20} color="#1361A4" />
          </ListItemIcon>
          <ListItemText
            primary="Transferir para outro fornecedor"
            primaryTypographyProps={{ fontSize: 14 }}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default MoveCategorySelect;
